import { Ziggy } from '@/modules/shared/helpers/facades/ziggy'
import { vsingleton } from '@niknevis/vue-modules'

@vsingleton()
export class WriterInfoRoutes {
  index() {
    return Ziggy
      .route('writer.info.index')
      .toString()
  }

  updateBankAccount() {
    return Ziggy
      .route('writer.info.update_bank_account')
      .toString()
  }
}
